import { BiEditAlt, BiTrash } from "react-icons/bi";
import KebabMenu, { Line } from "../../kebabMenu/KebabMenu";

interface NoteMenuProps {
    onEdit: () => void;
    onDelete: () => void;
}

const NoteMenu = ({ onEdit, onDelete }: NoteMenuProps) => {
    const lines: Line[] = [
        {
            id: 0,
            label: "main.edit",
            icon: BiEditAlt,
            clickHandler: onEdit,
        },
        {
            id: 2,
            label: "main.delete",
            icon: BiTrash,
            clickHandler: onDelete,
        },
    ];

    return (
        <div style={{ zIndex: 10, borderRadius: 5 }}>
            <KebabMenu
                lines={lines}
                activeColor="var(--tertiary-deep)"
                buttonClasses=""
                position="left"
            />
        </div>
    );
}; 

export default NoteMenu;